import { Component, ChangeDetectionStrategy, inject, effect, signal, CUSTOM_ELEMENTS_SCHEMA, NgZone } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CustomRouteService } from '../../services/custom-route.service';

@Component({
  selector: 'app-welcome-planner-view',
  standalone: true,
  imports: [
    TranslateModule
  ],
  templateUrl: './welcome-planner-view.component.html',
  styleUrls: ['./welcome-planner-view.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WelcomePlannerViewComponent {
  private _customRouteService = inject(CustomRouteService);
  private _ngZone = inject(NgZone); // change detection control (setTimeout)
  
  protected isWelcomeViewShown = this._customRouteService.isWelcomeViewShown;
  
  protected allReadyView = signal(true);
  
  private _timeoutId: number | null = null;
  
  hideAllReadyView = effect(() => {
    if (this._timeoutId) {
      clearTimeout(this._timeoutId);
    }
    
    this._ngZone.runOutsideAngular(() => {
      this._timeoutId = window.setTimeout(() => {
        this._ngZone.run(() => {
          this.allReadyView.set(false);
        });
      }, 3000);
    });
  }, { allowSignalWrites: true }); 
  

  protected handleGoToPlannerClick() {
    this._customRouteService.setIsWelcomeViewShown(false);
  }
  
  ngOnDestroy(): void {
    if (this._timeoutId) {
      clearTimeout(this._timeoutId);
      this._timeoutId = null;
    }
  }
}
